import { StoryblokComponent } from '@storyblok/react';

import { getSpacingFromStory } from 'apps/urban/utils/getSpacingFromStory';
import Image from 'next/image';

import { getColorFromStory } from '../../utils/getColorFromStory';
import { patchedStoryblokEditable } from '../../utils/patchedStoryblokEditable';
import {
  IconWrapper,
  USPBlockDescriptionWrapper,
  USPBlockItemsWrapper,
  USPBlockTitleWrapper,
  USPBlockWrapper,
} from './USPBlock.style';
import { USPBlockProps } from './USPBlock.types';

export const USPBlock = ({ blok, className }: USPBlockProps) => {
  const {
    items,
    title,
    description,
    divider,
    backgroundColor,
    gap,
    titleIcon,
    desktopPadding,
    mobileVerticalPadding,
    mobileInlinePadding,
  } = blok;

  const gapSpacing = getSpacingFromStory(gap);
  const paddingDesktop = getSpacingFromStory(desktopPadding);
  const verticalPaddingMobile = getSpacingFromStory(mobileVerticalPadding);
  const inlinePaddingMobile = getSpacingFromStory(mobileInlinePadding);
  return (
    <USPBlockWrapper
      className={className}
      gapSpacing={gapSpacing}
      desktopPadding={paddingDesktop}
      verticalPaddingMobile={verticalPaddingMobile}
      inlinePaddingMobile={inlinePaddingMobile}
      backgroundColor={getColorFromStory(backgroundColor)}
      {...patchedStoryblokEditable(blok)}
    >
      {!!title?.length &&
        (titleIcon?.filename ? (
          <USPBlockTitleWrapper>
            <IconWrapper>
              <Image src={titleIcon.filename} alt={titleIcon?.alt ?? 'title-icon'} layout="fill" />
            </IconWrapper>
            <StoryblokComponent blok={title[0]} />
          </USPBlockTitleWrapper>
        ) : (
          <StoryblokComponent blok={title[0]} />
        ))}

      {!!divider?.length && <StoryblokComponent blok={divider[0]} />}

      <USPBlockItemsWrapper>
        {items.map((item) => (
          <StoryblokComponent blok={item} key={item?._uid} />
        ))}
      </USPBlockItemsWrapper>

      {!!description?.length && (
        <USPBlockDescriptionWrapper>
          <StoryblokComponent blok={description[0]} />
        </USPBlockDescriptionWrapper>
      )}
    </USPBlockWrapper>
  );
};
